import React, { FC } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "../store";

const change = -0.57;

const mapState = (state: RootState) => ({
  change: state.user.change,
});

const mapDispatch = {
  setWallet: () => ({ change: 0 }),
};

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>;

type Props = PropsFromRedux & { change: number };

const AssetChange: FC<Props> = (props: Props) => {
  return (
    <div className="w-auto h-auto flex text-2xl text-white">
      {props.change > 0 ? (
        <p className="text-green-600">{"+" + props.change + "%"}</p>
      ):(
        <p className="text-red-700">{props.change + "%"}</p>
      )}
    </div>
  );
};

export default connector(AssetChange);